function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { COINBASE_DOMAIN } from '../../constants.js';
import { useLogger } from '../../providers/LoggerProvider.js';
import { cleanUrlDuplicateSlashes } from '../../utils/cleanUrlDuplicateSlashes.js';
import { getIsAnchorLink } from '../../utils/getIsAnchorLink.js';
import { getIsRelativeUrl } from '../../utils/getIsRelativeUrl.js';
import { getUrlWithProtocol } from '../../utils/getUrlWithProtocol.js';

// TODO: Replace with Array.prototype.findLastIndex after upgrading to TypeScript 5+
const findLastIndex = (array, matchFn) => {
  const temp = array.slice();
  const index = temp.reverse().findIndex(matchFn);
  return index > -1 ? array.length - 1 - index : index;
};
const getBaseDomain = hostname => {
  const parts = hostname.split('.');
  const lastTLDIndex = findLastIndex(parts, p => p.length > 3);
  return parts.slice(Math.max(0, lastTLDIndex)).join('.');
};
const useIsExternalUrl = url => {
  const _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    hostname = _useState2[0],
    setHostname = _useState2[1];
  const _useLogger = useLogger(),
    logInfo = _useLogger.logInfo;
  useEffect(() => setHostname(window.location.hostname), []);
  if (!url || getIsRelativeUrl(url) || getIsAnchorLink(url)) return false;
  const cleanUrl = cleanUrlDuplicateSlashes(url);
  if (!hostname) return true;
  try {
    const urlWithProtocol = getUrlWithProtocol(cleanUrl);
    const urlHostname = new URL(urlWithProtocol).hostname;
    const urlBaseDomain = getBaseDomain(urlHostname);
    return urlBaseDomain !== getBaseDomain(hostname) && urlBaseDomain !== COINBASE_DOMAIN;
  } catch (error) {
    logInfo(`Error validating external URL: ${url}`, error.message);
    return true;
  }
};
export { useIsExternalUrl };
//# sourceMappingURL=useIsExternalUrl.js.map
